// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Backdrop-module__Backdrop--bDOWQ{
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 300;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0,0.5);
}
.Backdrop-module__BackdropSpinner--j_5VY {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1301;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0,0.5);
}`, "",{"version":3,"sources":["webpack://./src/common/components/UI/Backdrop/Backdrop.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,OAAO;IACP,MAAM;IACN,iCAAiC;AACrC;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,OAAO;IACP,MAAM;IACN,iCAAiC;AACrC","sourcesContent":[".Backdrop{\r\n    width: 100%;\r\n    height: 100%;\r\n    position: fixed;\r\n    z-index: 300;\r\n    left: 0;\r\n    top: 0;\r\n    background-color: rgba(0,0,0,0.5);\r\n}\r\n.BackdropSpinner {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: fixed;\r\n    z-index: 1301;\r\n    left: 0;\r\n    top: 0;\r\n    background-color: rgba(0,0,0,0.5);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Backdrop": `Backdrop-module__Backdrop--bDOWQ`,
	"BackdropSpinner": `Backdrop-module__BackdropSpinner--j_5VY`
};
export default ___CSS_LOADER_EXPORT___;
